import React from "react";
import { Flex, message } from 'antd';
import { TagOutlined, UsergroupAddOutlined, CreditCardOutlined } from '@ant-design/icons';
import { getCurrentShopId } from '../../shop/get-current-shop';
import CouponCard from './card';

export default (props) => {
    const [ couponList, setCouponList ] = React.useState([]);
    const [shopId, setShopId] = React.useState(null);
    
    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getCouponList();
        }
    }, [shopId]);

    const getCouponList = async () => {
        if (!shopId) return;
        
        const response = await fetch('/api/coupon/list' + '?shopId=' + shopId);
        const result = await response.json();

        if (result?.success) {
            setCouponList(result.data.rows);
        }else {
            message.error(result.message);
        }
    }; 

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-3 md:gap-4 justify-items-center">
            {
                couponList.map((item, index) => {
                    return <CouponCard content={item} key={index} />
                })
            }
        </div>
    )
}